import './Loader.css'

const Loader = () => {
    return (
        <div className='loading'>
            <div className='lds-roller'>
                <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            </div>
        </div>
        
    )
}

export default Loader;